(function () {
  'use strict';

  // Carousel
  document.addEventListener('DOMContentLoaded', function () {
    var prevBtn = document.querySelector('.Pdp-Formate-Chevron-Container.prev');
    var nextBtn = document.querySelector('.Pdp-Formate-Chevron-Container.next');
    var cards = document.querySelectorAll('.Pdp-Formate-Card');

    var currentIndex = 0;
    var maxVisible;

    function setMaxVisible() {
      if (window.innerWidth >= 320 && window.innerWidth <= 767) {
        maxVisible = 1;
      } else if (window.innerWidth >= 767 && window.innerWidth <= 1023) {
        maxVisible = 2;
      } else {
        maxVisible = 3;
      }
    }

    // Set up the display for the cards
    function updateCardsDisplay() {
      // Hide all cards first
      cards.forEach(function (card) {
        card.style.display = 'none';
      });

      // Show only the visible cards
      for (var i = 0; i < maxVisible && i < cards.length; i++) {
        cards[i].style.display = 'flex';
      }
    }

    // Set initial maxVisible and update the display
    setMaxVisible();
    updateCardsDisplay();

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        cards[currentIndex + maxVisible - 1].style.display = 'none';
        currentIndex--;
        cards[currentIndex].style.display = 'flex';
      }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < cards.length - maxVisible) {
        cards[currentIndex].style.display = 'none';
        currentIndex++;
        cards[currentIndex + maxVisible - 1].style.display = 'flex';
      }
    });

    // Update maxVisible and display when the window is resized
    window.addEventListener('resize', function () {
      setMaxVisible();
      updateCardsDisplay();
    });
  });

  // Responsive
  function updateResponsivePdpFormate() {
    var screenWidth = window.innerWidth;

    // ...............
    // MOBILE.........
    // ...............

    if (screenWidth >= 320 && screenWidth <= 767) {
      var pdpFormateHeadline = document.querySelector('.Pdp-Formate-Headline-Wrapper h3');
      if (pdpFormateHeadline) {
        pdpFormateHeadline.classList.remove('text-headline-m-desktop');
        pdpFormateHeadline.classList.add('text-headline-m-uppercase-mobile');
      }
    }

    // ................
    // TABLET..........
    // ................

    if (screenWidth >= 768 && screenWidth <= 1023) {
      var pdpFormateHeadline = document.querySelector('.Pdp-Formate-Headline-Wrapper h3');
      if (pdpFormateHeadline) {
        pdpFormateHeadline.classList.remove('text-headline-m-desktop');
        pdpFormateHeadline.classList.add('text-headline-m-uppercase-mobile');
      }
    }

    // ................
    // LAPTOP..........
    // ................

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      var pdpFormateHeadline = document.querySelector('.Pdp-Formate-Headline-Wrapper h3');
      if (pdpFormateHeadline) {
        pdpFormateHeadline.classList.add('text-headline-m-desktop');
        pdpFormateHeadline.classList.remove('text-headline-m-uppercase-mobile');
      }
    }

    // ...............
    // DESKTOP........
    // ...............

    if (screenWidth >= 1439) {
      var pdpFormateHeadline = document.querySelector('.Pdp-Formate-Headline-Wrapper h3');
      if (pdpFormateHeadline) {
        pdpFormateHeadline.classList.add('text-headline-m-desktop');
        pdpFormateHeadline.classList.remove('text-headline-m-uppercase-mobile');
      }
    }
  }

  updateResponsivePdpFormate();
  window.addEventListener('resize', updateResponsivePdpFormate);
})();
